export const m3l0Solution = `// Integer types implement basic comparison and arithmetic operators.
// Felt252 operations should be avoided where possible, as they could have unwanted behavior.

use debug::PrintTrait;
// do not modify code on this line or above

fn poly(x: usize, y: usize) -> usize {
    let mut res = x * x * x + y - 2_usize;
    res // Do not change
}

// do not modify code on this line or below

#[test]
fn test_poly() {
    let res = poly(5_usize, 3_usize);
    assert(res == 126_usize, 'Error message');
    assert(res < 300_usize, 'res < 300');
    assert(res <= 300_usize, 'res <= 300');
    assert(res > 20_usize, 'res > 20');
    assert(res >= 2_usize, 'res >= 2');
    assert(res != 27_usize, 'res != 27');
}`;
